import { track } from '@hex/shared/tracking';
import { Button, Flex, tokens, Typography, View } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import { LoanCalculatorForm } from '../../types';
import { DonutAndNumbers } from './components/DonutAndNumbers';
import { MoreInformationCost } from './components/MoreInformationCost';

type Props = {
  data?: LoanCalculatorForm;
};

export function Results({ data }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <View marginLeft={{ base: -12, sm: -16, md: -32 }} marginRight={{ base: -12, sm: -16, md: -32 }}>
        <View
          backgroundColor={tokens.color.backgroundSignature.value}
          borderRadius={tokens.size.radiusMd}
          overflow={'hidden'}
          paddingTop={{ base: 24, md: 24 }}
          paddingBottom={{ base: 24, md: 24 }}
          paddingLeft={{ base: 24, md: 24 }}
          paddingRight={{ base: 24, md: 24 }}
          marginTop={{ base: -24, md: -32 }}
        >
          <Typography.Heading
            textAlign={'center'}
            margin={tokens.size.spacing3xs}
            level={5}
            elementType={'h2'}
            UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}
            marginBottom={{ base: 24, md: 16 }}
          >
            {t('results.heading')}
          </Typography.Heading>

          <DonutAndNumbers data={data} />

          <Typography.Subheading
            textAlign={'center'}
            marginTop={tokens.size.spacingMd}
            size={'md'}
            UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}
          >
            {t('results.subHeading')}
          </Typography.Subheading>

          <Flex flexFlow={'row wrap'} justifyContent={'center'}>
            <Button
              variant={'primary'}
              name={'apply-for-loan-commitment'}
              marginTop={tokens.size.spacingLg}
              data-test-id={'apply-for-loan-commitment'}
              aria-label={t('button.applyForLoan')}
              onPress={() => {
                track('Housing:Mortgage:Cost application');
                window.open(t('results.applyForLoanLink'), '_blank', 'noopener,noreferrer');
              }}
            >
              {t('button.applyForLoan')}
            </Button>
          </Flex>
        </View>
      </View>
      <MoreInformationCost data={data} />
    </>
  );
}
